$(function(){
  const scrollboxUl =document.querySelector('.scrollbox-ul');

  const box7Video = document.getElementById('box7-video');
  const canvas = document.getElementById("box7-video_canvas");
  const context = canvas.getContext("2d");
  const box7Img =document.querySelector('.box7-img');
  const box7ImgText =document.querySelector('.box7-img-text');
  const box7ImgText2 =document.querySelector('.box7-img-text2');
  
  let videoSub1 = 0;
  let videoSub2 = 0;
  let hasPlayed = false;

  // box7Video.addEventListener('timeupdate', () => {
  //   const currentTime = box7Video.currentTime;
  //   if (currentTime >= 2 && videoSub1 == 0) {
  //     box7ImgText.style.display = 'none';
  //     videoSub1++
  //   }
  //   if (currentTime >= 3 && videoSub2 == 0) {
  //     box7Text.classList.add('active');
  //     videoSub2++
  //   }
  // });
  // box7Video.addEventListener('ended', () => {
  //   box7Img.classList.add('active');
  // });

  // const box6Video = document.getElementById("box6-video");

  // let videoUrl = ''
  // if(windowW < 1920){
  //   videoUrl = 'https://cdn.shopify.com/videos/c/o/v/5a34853a3e1440cc8573073bf12b75ee.mp4'
  // }else{
  //   videoUrl = 'https://cdn.shopify.com/videos/c/o/v/5a34853a3e1440cc8573073bf12b75ee.mp4'
  // }


    
  

  ScrollTrigger.matchMedia({
    "(min-width: 1025px)": function(){

      ScrollTrigger.create({
        trigger: '.box4-bg',
        start: 'top top',
        end:'+=80%',
        scrub: true,
        pin:true,
        onUpdate(self){
          let imgIndex = Math.ceil(self.progress * 3);
    
          if(imgIndex == 1){
            scrollboxUl.style.transform = 'translate(0%)'
          }
          if(imgIndex == 2){
            scrollboxUl.style.transform = 'translate(-100%)'
          }
          if(imgIndex == 3){
            scrollboxUl.style.transform = 'translate(-200%)'
          }
          
        }
      })

    let go6 = 0
    const frameCount = 37;
    const images = []

    canvas.width = 1440;
    canvas.height = 900;
    const currentFrame = index => (
      `https://cdn.shopify.com/s/files/1/0604/6410/3654/files/Go_6_05_${(index).toString().padStart(1, '0')}.jpg`
    );
    
    for (let i = 1; i < frameCount; i++) {
      const img = new Image();
      img.src = currentFrame(i);
      images.push(img);
    }

    ScrollTrigger.create({
      trigger: '.box7-bg',
      start: 'top top',
      end:'+=160% bottom',
      scrub: true,
      pin:true,
      onUpdate(self){
        
          let imgIndex = Math.ceil(self.progress * frameCount);
          go6 = imgIndex - 2
          
          if (go6 < 0) go6 = 0
    
          if(go6<=frameCount){
            render()
          }

          if(go6>30) {
            box7ImgText.classList.add('active');
            box7ImgText2.classList.add('active');
            // line3.classList.add('active');
          }else{
            box7ImgText.classList.remove('active');
            box7ImgText2.classList.remove('active');
            // line3.classList.remove('active');
          }
          
        }
    })
    
    images[0].onload = render;
    
    function render() {
      context.clearRect(0, 0, canvas.width, canvas.height);
      context.drawImage(images[go6], 0, 0, canvas.width, canvas.height); 
    }

      // ScrollTrigger.create({
      //   trigger: '.box7',
      //   start: 'top 60%',
      //   scrub: true,
      //   onEnter(){
      //     if (!hasPlayed) {
      //       box7Video.play();
      //       hasPlayed = true;
      //     }
      //   }
      // })

    },
    "(max-width: 1024px)": function(){

    }
  })


})
